import { isDesktopBreakpoint } from '@theme/utilities';

const ARCHIVE_TEMPLATE = 'collection.archive';
const ARCHIVE_INTRO_MAX_WAIT = 2400;
const ARCHIVE_INTRO_MIN_DURATION = 650;
const ARCHIVE_INTRO_REVEAL_DURATION = 900;
const ARCHIVE_INTRO_REDUCED_DURATION = 1;

runArchiveIntro();

async function runArchiveIntro() {
  const main = document.querySelector('main[data-template]');
  if (main?.dataset.template !== ARCHIVE_TEMPLATE || window.__masonsArchiveIntroPlayed) return;

  const section = main.querySelector('.main-collection--archive');
  const shopifySection = section?.closest('.shopify-section');
  const signature = section?.querySelector('.collection-wrapper--archive .__signature');
  const backdrop = shopifySection?.querySelector('.archive-intro-overlay');
  const cards = Array.from(section?.querySelectorAll('.product-grid__item--archive') ?? []);

  if (
    !(section instanceof HTMLElement) ||
    !(shopifySection instanceof HTMLElement) ||
    !(signature instanceof HTMLElement) ||
    !(backdrop instanceof HTMLElement) ||
    cards.length === 0
  ) {
    cleanupArchiveIntro(shopifySection);
    return;
  }

  shopifySection.dataset.archiveIntro = 'active';
  window.__masonsArchiveIntroFailsafe = window.setTimeout(() => {
    cleanupArchiveIntro(shopifySection);
  }, 6000);

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  await Promise.race([
    Promise.all([wait(ARCHIVE_INTRO_MIN_DURATION), waitForArchiveCards(cards)]),
    wait(ARCHIVE_INTRO_MAX_WAIT),
  ]);

  shopifySection.dataset.archiveIntro = 'revealing';
  shopifySection.getBoundingClientRect();
  disableArchiveIntroBoot();

  await wait(prefersReducedMotion ? ARCHIVE_INTRO_REDUCED_DURATION : ARCHIVE_INTRO_REVEAL_DURATION);

  cleanupArchiveIntro(shopifySection);
  window.__masonsArchiveIntroPlayed = true;
}

async function waitForArchiveCards(cards) {
  const introCards = cards.slice(0, isDesktopBreakpoint() ? 5 : 4);
  const images = introCards
    .map((card) => card.querySelector('img'))
    .filter((image) => image instanceof HTMLImageElement);

  for (const image of images) {
    image.loading = 'eager';
    image.setAttribute('fetchpriority', 'high');
  }

  await Promise.all([waitForWindowLoad(), Promise.all(images.map(waitForImage))]);
}

function cleanupArchiveIntro(section = document.querySelector('main[data-template="collection.archive"] .main-collection--archive')?.closest('.shopify-section')) {
  if (typeof window.__masonsArchiveIntroFailsafe === 'number') {
    window.clearTimeout(window.__masonsArchiveIntroFailsafe);
    window.__masonsArchiveIntroFailsafe = null;
  }

  disableArchiveIntroBoot();
  section?.removeAttribute('data-archive-intro');
}

function disableArchiveIntroBoot() {
  document.documentElement.removeAttribute('data-archive-intro-boot');
}

/**
 * @param {number} ms
 * @returns {Promise<void>}
 */
function wait(ms) {
  return new Promise((resolve) => {
    window.setTimeout(resolve, ms);
  });
}

/**
 * @returns {Promise<void>}
 */
function waitForWindowLoad() {
  if (document.readyState === 'complete') return Promise.resolve();

  return new Promise((resolve) => {
    window.addEventListener('load', () => resolve(), { once: true });
  });
}

/**
 * @param {HTMLImageElement} image
 * @returns {Promise<void>}
 */
function waitForImage(image) {
  if (image.complete) return Promise.resolve();

  return new Promise((resolve) => {
    const done = () => {
      image.removeEventListener('load', done);
      image.removeEventListener('error', done);
      resolve();
    };

    image.addEventListener('load', done, { once: true });
    image.addEventListener('error', done, { once: true });
  });
}
